module.exports = __webpack_public_path__ + "img/moon.f5c68bfd.svg";